import React, {Component} from 'react';
import PropTypes from 'prop-types';
import loadUser from './helpers/loadUser';
import loadSession from './helpers/loadSession';
import selectPlace from './helpers/selectPlace';
import Header from './header';
import Playbill from './playbill';
import Footer from './footer';
import Scheme from './scheme';
import TicketsTooltip from './tooltip';
import Aside from './aside';
import Popup from '../popup';

import {setCookie, monthTimeout, getCookie} from '../../helpers/cookie';
import Timer from './timer';
import Preloader from './helpers/preloader';

class Buy extends Component {
  static propTypes = {
    session: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      .isRequired,
    canBuy: PropTypes.bool,
    selected: PropTypes.arrayOf(PropTypes.number),
    route: PropTypes.object.isRequired,
    routeLogin: PropTypes.object.isRequired,
  };

  static defaultProps = {
    canBuy: true,
    selected: [],
  };

  constructor(props) {
    super(props);

    this.state = {
      id: props.session,
      selected: props.selected || [],
      session: {},
      user: {},
      loading: true,
      firstLoad: true,
      ticketsTooltipShow: false,
      step: 'scheme', // login, info, checkout
      beforeStep: 'scheme',
      sessionInfo: {},
      checkout: {
        phone: null,
        email: null,
        bonusPay: 0,
        lastName: '',
        firstName: '',
        middleName: '',
      },
      amount: 0,
      maxBonusPay: 0,
      minPayAmount: 1,
      errors: [],
      enableTimer: false,
      orderId: null,
      /*
      id: props.session,
      wait: 0,
      loading: true,
      user: null,
      session: {},
      places: [],
      avatar: [],
      selected: props.selected || [],
      noBonus: false,
      key: 0,
      exit: null,
      openTown: false,
      ask: false,
      screen: 1,
      is_disabled: false,*/
    };
  }

  componentDidMount() {
    const script = document.createElement('script');

    script.src = 'https://pay.google.com/gp/p/js/pay.js';
    script.async = true;

    document.body.appendChild(script);

    const {session} = this.props;

    loadSession(session)
    .then(resp => {
      this.setState({
        session: resp,
        ticketsTooltipShow: false,
      });
    })
    .then(() => {
      const amount = this.calcAmout();
      const maxBonusPay = this.getMaxBonusPay(amount);
      this.setState({amount, maxBonusPay});
    })
    .then(() => {
      this.setState({loading: false, firstLoad: false});
    })
    .catch(error => {
      this.setStep({
        errors: this.state.errors.push(error),
      });
    });

    loadUser().then(resp => {
      this.setState(prevState => ({
        user: resp,
        checkout: {
          ...prevState.checkout,
          phone: resp.phone,
          email: resp.email,
          bonusPay: 0,
        },
      }));
    });
  }

  componentWillUnmount() {
    this.setState({
      selected: [],
      amount: 0,
      maxBonusPay: 0,
    });
  }

  setOrderId = value => this.setState({orderId: value});

  changeSession(sessionId) {
    this.setState({
      id: sessionId,
      loading: true,
      selected: [],
      ticketsTooltipShow: false,
      amount: 0,
      maxBonusPay: 0,
    });

    loadSession(sessionId).then(resp => {
      this.setState({
        session: resp,
        loading: false,
        ticketsTooltipShow: false,
      });
    });
  }

  updateUser = user => {
    this.setState(prevState => ({
      user: user,
      checkout: {
        ...prevState.checkout,
        phone: user.phone,
        email: user.email,
        bonusPay: 0,
      },
    }));
  };

  calcBonusPay = selected => {
    const {session, user} = this.state;

    if (session.cinema.no_bonus) return 0;

    const amount = this.calcAmout(selected);
    const maxBonusPay = this.getMaxBonusPay(amount);

    if (user.balance) return user.balance > maxBonusPay ? maxBonusPay : user.balance;

    return 0;
  };

  // calcBonusPay = selected => {
  //   const { session, user } = this.state;

  //   if (session.cinema.no_bonus) return 0;

  //   const selectedPlaces = session.places.filter(place =>
  //     selected.includes(place.id),
  //   );
  //   const amount = selectedPlaces.reduce(function(sum, place) {
  //     return sum + place.price;
  //   }, 0);

  //   if (user.balance) return user.balance > amount ? amount : user.balance;

  //   return 0;
  // };

  getMaxBonusPay(amount) {
    const {session, minPayAmount, selected} = this.state;

    const selectedPlaces = session.places.filter(place =>
      selected.includes(place.id),
    );

    return amount > 0 ? amount - (minPayAmount * selectedPlaces.length) : 0;
  }

  selectPlace(placeId) {
    const {selected, checkout, id} = this.state;

    const index = selected.indexOf(placeId);

    if (index > -1) {
      // If selected earlier = remove select
      selected.splice(index, 1);
      const newBonusPay = this.calcBonusPay(selected);
      const amount = this.calcAmout(selected);
      const maxBonusPay = this.getMaxBonusPay(amount);

      if (selected.length) {
        this.setState({
          selected,
          amount,
          maxBonusPay,
          checkout: {
            ...checkout,
            bonusPay:
              checkout.bonusPay < newBonusPay ? checkout.bonusPay : newBonusPay,
          },
        });
      } else {
        this.setState({
          selected: [],
          step: 'scheme',
          ticketsTooltipShow: false,
          amount: 0,
          maxBonusPay: 0,
          checkout: {
            ...checkout,
            bonusPay: 0,
          },
        });
      }
    } else {
      // If not selected = check available places
      selectPlace(id, placeId).then(resp => {
        if (resp.selected && selected.indexOf(placeId) == -1)
          selected.push(placeId);
        const amount = this.calcAmout();
        const maxBonusPay = this.getMaxBonusPay(amount);
        this.setState({
          selected: selected,
          places: resp.places,
          amount,
          maxBonusPay,
          // checkout: {
          //   phone: checkout.phone,
          //   email: checkout.email,
          //   bonusPay: checkout.bonusPay == 0 ? 0 : this.calcBonusPay(selected),
          // }
        });
      });
    }
  }

  setStep(stepName) {
    const {checkout, selected} = this.state;

    // Set bonus pay if click "Checkout" on scheme step
    // and not set bonuses before
    if (stepName == 'checkout' && checkout.bonusPay == 0) {
      this.setState({
        step: stepName,
        ticketsTooltipShow: false,
        checkout: {
          ...checkout,
          bonusPay: this.calcBonusPay(selected),
        },
      });
    } else {
      this.setState({
        step: stepName,
        ticketsTooltipShow: false,
      });
    }
  }

  orderCancel = async () => {
    const route = `/local/php_interface/api/v1/buy/cancel/?order_id=${this.state.orderId}`;
    const result = await fetch(route);

    setCookie('UNPAID_ORDER', '');
    setCookie('PAYMENT_LINK', '');
    setCookie('ORDER_ID', '');
    setCookie('SBPPAY', '');
    setCookie('PAYMENT_METHOD', '');
    setCookie('PUSHKIN_FIO', '');
    this.setState({enableTimer: false});
  };

  timerDisable = () => {
    if (this.state.step === 'choicePayment') {
      this.orderCancel();
      window.expire_date = null;
      this.setStep('checkout');
    }
  };

  checkStep = async () => {
    const {step} = this.state;
    const sessionInfo = await this.getSessionInfo();

    this.state.beforeStep = step;
    if (step === 'choicePayment') {
      this.orderCancel();
      this.setStep('checkout');
    } else if (step === 'checkout' && sessionInfo) {
      this.setStep('info');
    } else {
      this.setStep('scheme');
    }
  };

  calcAmout = (selected = this.state.selected) => {
    const {session} = this.state;

    const selectedPlaces = session.places.filter(place =>
      selected.includes(place.id),
    );

    return selectedPlaces.reduce((sum, place) => sum + place.price, 0);
  };

  editCheckout(name, val) {
    const {checkout} = this.state;
    checkout[name] = val;
    this.setState({checkout});
  }

  // Возвращаем ошибки от детей
  returnError = value =>
    this.setState({
      errors: value,
    });

  timerCallback = enable => this.setState({enableTimer: enable});

  /**
   * Ajax инфа он сеансе для доп шага
   * @returns {Promise<null|*>}
   */
  loadSessionInfo = async () => {
    try {
      let url = this.props.route.info + '?sessionId=' + this.state.session.id;
      const response = await fetch(url);
      const data = await response.json();
      if (data.status === 'success') {
        return data.data;
      }
    } catch (error) {
    }
    return null;
  };

  /**
   * Получаем информацию о сеансе для отображения доп шага
   * @returns {Promise<null|Object>}
   */
  getSessionInfo = async () => {
    const {sessionInfo, session} = this.state;
    let result = sessionInfo[session.id];
    //console.log('sessionInfo - '+result);

    if (result === undefined) {
      result = await this.loadSessionInfo();
      this.state.sessionInfo[session.id] = result;

    }

    return result;
  };

  /**
   * Метод для определения каким будет след шаг после схемы
   * @returns {Promise<void>}
   */
  nextStepAfterSchema = async () => {
    // console.log('nextStepAfterSchema');
    const info = await this.getSessionInfo();

    // console.log('info - '+info);
    if (info) {
      // console.log('info set');
      this.setStep('info');
    } else {
      this.setStep('checkout');
    }
  };

  render() {
    const {
      id,
      session,
      loading,
      firstLoad,
      selected,
      ticketsTooltipShow,
      step,
      user,
      checkout,
      errors,
      amount,
      maxBonusPay,
    } = this.state;

    if (loading && firstLoad) {
      return <Preloader/>;
    }

    const {route, routeLogin} = this.props;

    if (errors.length) {
      if (errors[0].detail == 'Ошибка 131') {
        return (
          <Popup
            type="alert"
            status="error"
            title="Ошибка"
            message="Сеанс уже начался. Покупка билетов недоступна."
            button="Назад"
          />
        );
      }
      return (
        <Popup
          type="alert"
          status="error"
          title="Ошибка"
          message="Ошибка получения сеанса. Попробуйте еще раз."
          button="Назад"
        />
      );
    }

    if (session.film == undefined) return null;

    const unpaidOrder = getCookie('UNPAID_ORDER');

    const expire =
      window.expire_date != null
        ? window.expire_date
        : Date.now() + 6 * 60 * 1000 + 50000;

    return (
      <React.Fragment>
        <Timer
          expireAtMs={expire}
          enable={this.state.enableTimer}
          timerDisable={this.timerDisable}
        />
        <div className="scheme-popup">
          <Header
            name={session.film.name}
            cinema={session.cinema}
            hall={session.hall}
            datetime={session.datetime}
            forceUpdate={() => this.forceUpdate()}
            user={user}
          />
          {(!unpaidOrder || this.state.step === 'choicePayment') && (
            <Playbill
              current={id}
              timetable={session.timetable}
              onChange={sessionId => this.changeSession(sessionId)}
            />
          )}
          <Scheme
            loading={loading}
            session={session}
            selected={selected}
            onSelect={id => this.selectPlace(id)}
            amount={amount}
            maxBonusPay={maxBonusPay}
            checkout={checkout}
            nextStepAfterSchema={this.nextStepAfterSchema}
          />
          {(!unpaidOrder || this.state.step === 'choicePayment') && (
            <Footer
              session={session}
              selected={selected}
              checkout={checkout}
              user={user}
              showTooltip={() =>
                this.setState({ticketsTooltipShow: !ticketsTooltipShow})
              }
              onLogin={() => this.setStep('login')}
              amount={amount}
              nextStepAfterSchema={this.nextStepAfterSchema}
            />
          )}
          <TicketsTooltip
            session={session}
            selected={selected}
            show={ticketsTooltipShow}
            checkout={checkout}
            onDel={placeId => this.selectPlace(placeId)}
            onClose={() => this.setState({ticketsTooltipShow: false})}
          />
          <Aside
            step={step}
            session={session}
            selected={selected}
            user={user}
            checkout={checkout}
            onBackClick={() => this.checkStep()}
            showTooltip={() =>
              this.setState({ticketsTooltipShow: !ticketsTooltipShow})
            }
            onEditCheckout={(name, val) => this.editCheckout(name, val)}
            route={route}
            routeLogin={routeLogin}
            returnError={value => this.returnError(value)}
            sessionId={id}
            amount={amount}
            maxBonusPay={maxBonusPay}
            updateUser={user => this.updateUser(user)}
            enableTimerCallback={this.timerCallback}
            beforeStep={this.state.beforeStep}
            onSchema={() =>
              this.setStep('schema')
            }
            onLogin={() =>
              this.setStep('login')
            }
            onInfo={() =>
              this.setStep('info')
            }
            onCheckout={() =>
              this.setStep('checkout')
            }
            onChoicePayment={() => selected.length ? this.setStep('choicePayment') : null}
            onSbpPay={() =>
              this.setStep('sbpPay')
            }
            onPushkinPay={() =>
              this.setStep('pushkinPay')
            }
            setOrderId={this.setOrderId}
            sessionInfo={this.state.sessionInfo}
          />
        </div>
      </React.Fragment>
    );
  }
}

export default Buy;
